import React, { useState } from 'react';
import { useRequest } from 'ahooks';
import { ProductBrand } from '@/interface/product';
import { getProductBrandList } from '@/services/product';
import BrandCard from '../BrandCard';
import styles from './index.module.scss';

type ProductFunctionProps = {
  boxProductId: string;
  id?: string;
  initialProductBrandList?: ProductBrand[];
  productBrandListTotal?: number;
};
const pageSize = 15;
const CooperationBrand: React.FC<ProductFunctionProps> = ({
  boxProductId,
  id = 'cooperationBrand',
  initialProductBrandList = [],
  productBrandListTotal,
}) => {
  const [brandList, setBrandList] = useState(initialProductBrandList);
  const { loadingMore, loadMore, noMore } = useRequest(
    d => {
      // Server端获取第一页内容，Client端从第二页开始获取内容
      return getProductBrandList({ boxProductId, pageIndex: (d?.list.length || 0) / pageSize + 2, pageSize });
    },
    {
      manual: true,
      initialData: { list: initialProductBrandList, total: productBrandListTotal },
      formatResult(res) {
        return {
          list: res.data.list,
          total: res.data.total,
        };
      },
      onSuccess(res) {
        res.list?.length && setBrandList(brandList.concat(res.list));
      },
      loadMore: true,
      isNoMore: d => {
        // 计算是否有更多数据时要加上Server端请求的第一页数据（实际请求数据length小于pageSize也没事，代表在Server端第一页已请求完所有数据）
        return d ? d.list.length + pageSize >= d.total : false;
      },
    }
  );
  return (
    <>
      <section className={styles.section}>
        <h2 id={id} className={styles.title}>
          合作品牌
        </h2>
        <div className={styles.brandListWrapper}>
          {brandList.map(item => (
            <BrandCard key={item.boxProductBrandId} name={item.brandName} />
          ))}
        </div>
        {!noMore && (
          <button className={styles.loadMoreBtn} disabled={loadingMore} onClick={loadMore}>
            查看更多
          </button>
        )}
      </section>
      <p className={styles.infoOriginTip}>信息来源：由企服机构自主提供</p>
    </>
  );
};
export default CooperationBrand;
